import React, { useContext, useEffect, useState } from 'react';
import { Button, Checkbox, Spinner } from 'flowbite-react';
import CustomInput from '../../../../components/CustomInputs/CustomInput';
import { UserContext } from '../../../../contexts/UserContext';
import showToast from '../../../../components/CustomToast/toastHelper';
import client from '../../../../api/client';
import { FaMailBulk, FaMailchimp } from 'react-icons/fa';
import CustomModal from '../../../../components/Modal/CustomModal';
import CreatePinModal from '../../../../components/CreatePinModal/CreatePinModal';
import OtpVerificationModal from '../../../../components/OtpVerificationModal/OtpVerificationModal';
import ConfirmPinModal from '../../../../components/ConfirmPinModal/ConfirmPinModal';
interface PinSettingsProp {
    otp:string
}
const PinSettings = () => {
    const [otpSent, setOtpSent] = useState<boolean>(false)
    const [openPinModal, setOpenPinModal] = useState<boolean>(false)
    const [otp, setOtp] = useState<string>('')
    const [loading, setLoading] = useState<boolean>(false)
    const [openChangePinModal, setOpenChangePinModal] = useState<boolean>(false)
    const [openOtpVerificationModal, setOpenOtpVerificationModal] = useState<boolean>(false)
    const [hasPin, setHasPin] = useState<boolean>(false)
    const {userDetails} = useContext(UserContext) ?? {}
    const handleSendOtp = async() => {
        try {
            setLoading(true)
            const response = await client.post('/subsidiary/dashboard/pin/reset/send-otp', null);
            const message = response?.data?.message;
            showToast(message, "success")
            // setOtpSent(true)
            setOpenOtpVerificationModal(true)
        } catch (err: any) {

            if (err?.response?.data?.message === 'Please login again') {
                sessionStorage.clear();
                window.location.href = '/';
            } else {
                console.error('error getting data', err);
                const message = err?.response?.data?.message;
                showToast(message, "error")
            }
        }
        finally{
            setLoading(false)
        }
    }

    const handleSuccessfulPinChange =() =>{
        setOpenPinModal(false)
        setOtp('')
        setOtpSent(false)
    }
    useEffect(()=>{
        if(userDetails){
            if(!userDetails.user.pin ){
                setHasPin(false)
            }
            else{
                setHasPin(true)
            }
        }
    },[])
    return (
        <div>

            <div className='grid grid-cols-1 md:grid-cols-2 mt-8'>
                <div className='md:mx-4'>
                    <p className='text-3xl font-semibold mb-3'>Reset Transaction PIN</p>
                    <p className='text-sm'>To reset your transaction pin, you will have to verify your identity with a verification code</p>
                </div>
                <div>
                    {!otpSent && (
                        <>
                            <div>
                                <p className='font-bold'>Choose how you want to get the code</p>
                            </div>
                            <div>
                                <Button disabled={hasPin == false} onClick={() => handleSendOtp()} className='rounded-none bg-custom-button-green'>
                                    <div className='flex items-center gap-3'>
                                        <span><FaMailBulk /></span>
                                        {loading?<Spinner size='sm'/>:'Send via email'}
                                    </div>
                                </Button>
                            </div>
                        </>
                    )}
                    {otpSent && (
                        <>
                            <div>
                                <p className='font-bold'>Please enter the verification code sent to you</p>
                            </div>
                            <div className='space-y-4'>
                                <CustomInput

                                    type='number'
                                    label='Verification Code'
                                    name='oldpin'
                                    placeholder=''
                                    value={otp}
                                    onChange={(e: any) => setOtp(e.target.value)}
                                    maxLength={6} // Enforce maximum length
                                // inputMode="numeric" // Show numeric keyboard on mobile
                                />

                            </div>
                            <div className='w-full my-4 flex md:justify-between'>
                                <div></div>
                                <div className='flex gap-4'>
                                    <Button
                                        className='rounded-none bg-custom-button-green text-black font-semibold hover:bg-green-700 hover:text-white'
                                        onClick={()=>setOpenPinModal(true)}
                                    >
                                        Continue
                                    </Button>
                                </div>
                            </div>
                        </>
                    )}
                    <CustomModal title='' show={openOtpVerificationModal} dismissible icon='' size='md' onClose={() => setOpenOtpVerificationModal(false)}>
                        <OtpVerificationModal closeAllModals={()=>{setOpenOtpVerificationModal(false)}} type='reset' close={() => setOpenOtpVerificationModal(false) }/>
                    </CustomModal>
                </div>
            </div>

            <div className='grid grid-cols-1 md:grid-cols-2 mt-8 items-center'>
                <div className='md:mx-4'>
                    <p className='text-3xl font-semibold mb-3'>Change Transaction PIN</p>
                    <p className='text-sm'>To reset your transaction pin, you will have to provide your current pin and the new one</p>
                </div>
                <div className='flex items-center'>
                    <p  onClick={hasPin == false ? ()=> {showToast('You have not setup any transaction pin',"error")} :()=>setOpenChangePinModal(true)} className='underline text-green-700 hover:cursor-pointer'>Click here to initiate</p>
                </div>
            </div>
            <CustomModal size='md' show={openChangePinModal} dismissible icon='' onClose={()=>setOpenChangePinModal(false)}>
                <ConfirmPinModal onBackPress={()=>setOpenChangePinModal(false)} onComplete={()=>setOpenChangePinModal(false)}/>
                {/* <CreatePinModal closeAllModals={()=> setOpenChangePinModal(false)}  topMessage='Enter new PIN' downMessage='Confirm new PIN' close={()=>setOpenChangePinModal(false)} onSuccess={()=>setOpenChangePinModal(false)} type='change-pin' message='Kindly provide your old pin and enter your new pin below' buttonText='Next' /> */}
            </CustomModal>
        </div>
    );
};

export default PinSettings;